import React from "react";

import { InfoButton } from "../../../actions/InfoButton";

const PARTNER_TAG_MULTISELECT_EXPLANATION =
  "Tracking your partners' activity will help you have an insight on potential sub-contracting opportunities, and find warm introductions to relevant buyers.";

const COMPETITOR_TAG_MULTISELECT_EXPLANATION =
  "Tracking your competitors' activity will help you have an insight on their existing contracts and upcoming expiries. Use this data to anticipate and prepare for upcoming tenders.";

type ExplanationProps = {
  supplierType: "partner" | "competitor";
};
export function SupplierInputExplanation({ supplierType }: ExplanationProps): JSX.Element {
  const text = React.useMemo(() => {
    if (supplierType === "partner") return PARTNER_TAG_MULTISELECT_EXPLANATION;
    return COMPETITOR_TAG_MULTISELECT_EXPLANATION;
  }, [supplierType]);

  return <InfoButton tooltipOverlayStyle={{ whiteSpace: "pre-line", minWidth: 507 }} note={text} />;
}
